import {
  useEffect, useCallback, useState, useRef, useMemo,
} from 'react';
import { message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';

import deviceActions from '@state/device/actions';
import telemetryActions from '@state/telemetry/actions';
import devicesApi from '@api/devicesApi';
import getColumns from './getColumns';

function useDeviceListTable() {

  const { business_type_id } = useParams();

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const clientTarget = useSelector(({ user }) => user.clientTarget);
  const deviceRedux = useSelector(({ device: a }) => a.createNewDevice);
  const abortController = useRef(null);
  const unmountcomponent = useRef(true);
  // const timeoutRef = useRef();
  const timerLopping = useRef();
  const initPagination = useRef({ current: 1, pageSize: 20 });
  const history = useHistory();
  const search = '';
  const [valueFilter, setValueFilter] = useState('');
  // const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [devices, setDevices] = useState([]);
  const [pag, setPagination] = useState(initPagination.current);

  const [statusDevices, setStatusDevices] = useState('todos');

  const [isCreate, setIsCreate] = useState(false);
  const currentUser = useSelector(({ user }) => user);

  const abortLastRequest = useCallback(() => {

    if (abortController.current) {

      abortController.current.abort();
      abortController.current = null;

    }

  }, []);

  const handleTableChange = useCallback( // load device data
    (pagination, filter, sorter) => {

      // console.log('pagination, filter, sorter: ', pagination, filter, sorter);

      // const { id: client } = clientTarget;
      const { current, pageSize: limit } = pagination;
      const offset = (current - 1) * limit;

      // const { columnKey, order } = sorter || {};
      // const ordering = columnKey ? `${order === 'descend' ? '-' : ''}${columnKey}` : undefined;

      abortController.current = new AbortController();
      const { signal } = abortController.current;

      setLoading(true);
      if (timerLopping.current) clearTimeout(timerLopping.current);

      // devicesTelemetry
      devicesApi.getAllBusinessTypeById({
        signal, offset, limit, business_type_id,
      }).then(async (response) => {

        if (unmountcomponent && response) {

          if (response.length > 0) {

            const resp = {
              count: response[0]?.devicesList?.length || 0,
              results: response[0]?.devicesList || [],
              businesstype: response[0] || [],
            };
            // eslint-disable-next-line no-shadow
            const { results: devices, count: total, businesstype: business_type } = resp;
            setPagination({ ...pagination, total });
            setLoading(false);

            const newDevices = await Promise.all(devices.map(async (obj) => {

              const arrDevicesType = obj?.device_types.map((item) => item.name) || [];
              const device_types_name = arrDevicesType.join(', ');
              const objBusinessType = { id: business_type.id, name: business_type.name };
              const logo_full_url = business_type?.logo_full_url || '';
              const item = {
                ...obj, device_types_name, business_type: objBusinessType, logo_full_url,
              };
              return item;

            }));

            setDevices(newDevices);
            dispatch(telemetryActions.setAllDevicesData(devices));
            dispatch(telemetryActions.setInfoBusinessType(business_type));

          } else {

            setDevices([]);
            dispatch(telemetryActions.setInfoBusinessType({}));
            dispatch(telemetryActions.setAllDevicesData([]));

          }

          timerLopping.current = setTimeout(
            () => handleTableChange({ pagination, filter, sorter }),
            120000,
          );

        }

      })
        .catch((resError) => {

          if (signal.aborted) return;
          const { fem } = resError;
          // eslint-disable-next-line no-console
          console.log(t(fem));
          setLoading(false);

        });

    },
    [clientTarget, search, t],
  );

  useEffect( // mount component
    () => {

      // Guardo el negocio si se va a crear ya tenerlo
      const newDevice = { ...deviceRedux, business_type_id };
      dispatch(deviceActions.setCreateEditDevice(newDevice));

      handleTableChange(initPagination.current);
      return abortLastRequest;

    },
    // eslint-disable-next-line
    []
  );

  const createDevice = useCallback( // Go to create /crear-dispositivo
    () => {

      history.push('/dispositivos/crear-dispositivo');

    },
    [history],
  );

  const deleteDevice = useCallback((e) => { // Delete device by Id

    abortController.current = new AbortController();
    const { signal } = abortController.current;
    const { id } = e;
    devicesApi.deleteDeviceById({ signal, id })
      .then((response) => {

        if (unmountcomponent) {

          message.success(t('common.feedbacks.device_remove_success'));
          handleTableChange(initPagination.current);

        }

      })
      .catch((error) => {

        message.error(t('common.feedbacks.device_remove_failed'));

      });

  // eslint-disable-next-line
  }, []);

  const editDevice = useCallback((e) => { // edit device, save data device in redux

    const defaultData = {
      name: e.name,
      client: e.client,
      business_type_id: e?.business_type?.id || '',
      device_type_id: e?.device_types?.map((item) => (item.id)) || [],
      slvId: `${e?.slvId}` || '',
      gateway_id: e?.gateway?.id || '',
    };

    dispatch(deviceActions.setDeviceIdEdit(e.id));
    dispatch(deviceActions.setCreateEditDevice(defaultData));
    history.push('/dispositivos/editar-dispositivo');

  }, [dispatch, history]);

  const goToDeviceId = useCallback((device) => {

    // Route viejo
    /// /tablero-gener''al/almacenamiento/:device

    // Route Nuevo
    /// /tablero-general/:device
    // eslint-disable-next-line
    if (device?.business_type?.name.trim() === 'Retail' || device?.business_type?.name.trim() === 'Almacenamiento') {

      dispatch(telemetryActions.setDeviceId(device.id));
      history.push(`/tablero-general/almacenamiento/${device.id}`);

    } else {

      dispatch(telemetryActions.setDeviceId(device.id));
      history.push(`/tablero-general/${device.id}`);

    }
    // eslint-disable-next-line
 }, []);

  const columns = useMemo(
    () => getColumns(t, deleteDevice, editDevice, currentUser, goToDeviceId),
    [t, deleteDevice, editDevice, currentUser, goToDeviceId],
  );

  const arrayFilter = devices.filter((data) => {

    const nameFilter = data.name.toUpperCase().includes(valueFilter.toUpperCase());

    // Si el valor seleccionado es "todos", no apliques el filtro por estado
    if (statusDevices === 'todos') {

      return nameFilter; // Retornar el resultado del filtro por nombre

}

    // Si el valor seleccionado es "conectados", filtra por estado "Connected"
    if (statusDevices === 'conectados') {

      return (
        nameFilter
        && data.device_twin?.connection_state === 'Connected'
      );

}

    // Si el valor seleccionado es "desconectados", filtra por estado "Disconnected"
    if (statusDevices === 'desconectados') {

      return (
        nameFilter
        && data.device_twin?.connection_state === 'Disconnected'
      );

}

    return false; // Si no coincide con ninguno de los casos anteriores, no mostrarlo

});

    const getPermissonCreate = useCallback(() => {

      const currentUserRole = currentUser.role;
        // eslint-disable-next-line
        setIsCreate(!!(currentUserRole === 'Superadmin' || currentUserRole === 'Admin'));

    }, []);

    useEffect(() => {

      getPermissonCreate();

}, []);

  useEffect(() => () => {

    unmountcomponent.current = false;
    clearTimeout(timerLopping.current);

  });

  return {
    setValueFilter,
    handleTableChange,
    loading,
    arrayFilter,
    devices,
    columns,
    pagination: pag,
    createDevice,
    // onChangeSearch,
    statusDevices,
    setStatusDevices,
    goToDeviceId,
    isCreate,
  };

}

export default useDeviceListTable;
